// Safety net for stray debug logging in built bundles; console.error and console.warn are kept.
if (process.env.NODE_ENV === 'production') {
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    console.trace = noop;
    console.table = noop;
}

export default null;
